import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterLabel = ({ num, title, light = false }) => (
  <FadeIn className="flex items-center gap-4 mb-8">
    <span className={`font-serif italic text-lg ${light ? "text-gold" : "text-gold"}`}>{num}</span>
    <span className={`h-px w-12 ${light ? "bg-cream/40" : "bg-charcoal/20"}`} />
    <span className={`text-xs font-medium uppercase tracking-[0.25em] ${light ? "text-cream/80" : "text-charcoal/60"}`}>
      {title}
    </span>
  </FadeIn>
);
